import { useSyncExternalStore } from 'react';

// Lets an onboarding tour hold one sidebar section expanded while it points at its entries.
// Sections otherwise expand only on their own routes, so a tour running on any other page would
// have no child entry to anchor to.
//
// A module store rather than a context or a Redux field: the tour host and the sidebar are
// siblings under the dashboard layout (a provider would have to wrap the whole shell), and this
// is transient UI state that must not be persisted by redux-persist and rehydrated later.

type Listener = () => void;

const listeners = new Set<Listener>();
let spotlightedSectionId: string | null = null;

export const setSpotlightedNavSection = (sectionId: string | null): void => {
  if (spotlightedSectionId === sectionId) return;
  spotlightedSectionId = sectionId;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = (): string | null => spotlightedSectionId;

export const useSpotlightedNavSection = (): string | null =>
  useSyncExternalStore(subscribe, getSnapshot);
